import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { newsApi } from "../api/newsApi";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function NewsCreate() {
  const nav = useNavigate();

  const [titleAz, setTitleAz] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleRu, setTitleRu] = useState("");

  const [contentAz, setContentAz] = useState("");
  const [contentEn, setContentEn] = useState("");
  const [contentRu, setContentRu] = useState("");

  const [manualInsertedDate, setManualInsertedDate] = useState(null);
  const [youtubeLink, setYoutubeLink] = useState("");
  const [imageFile, setImageFile] = useState(null);

  const [saving, setSaving] = useState(false);

  const toLocalDateTimeString = (d) => {
    if (!d) return null;

    const pad = (n) => String(n).padStart(2, "0");

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
      d.getHours()
    )}:${pad(d.getMinutes())}`;
  };

  const submit = async (e) => {
    e.preventDefault();

    setSaving(true);

    try {
      await newsApi.create({
        titleAz,
        titleEn,
        titleRu,

        contentAz,
        contentEn,
        contentRu,

        manualInsertedDate: toLocalDateTimeString(manualInsertedDate),

        youtubeLink,

        imageFile,
      });

      nav("/news");
    } catch (err) {
      alert(err?.response?.data || err.message || "Create failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="pageTitle">Xəbər yarat</h1>

      <div className="card">
        <div className="cardHead">
          <span className="badge">multipart/form-data</span>
        </div>

        <div className="cardBody">
          <form className="form" onSubmit={submit}>
            <div>
              <span className="label">Başlıq (AZ) *</span>
              <input
                className="input"
                value={titleAz}
                onChange={(e) => setTitleAz(e.target.value)}
                required
              />
            </div>

            <div>
              <span className="label">Başlıq (EN)</span>
              <input
                className="input"
                value={titleEn}
                onChange={(e) => setTitleEn(e.target.value)}
              />
            </div>

            <div>
              <span className="label">Başlıq (RU)</span>
              <input
                className="input"
                value={titleRu}
                onChange={(e) => setTitleRu(e.target.value)}
              />
            </div>

            <div className="hr" />

            <div>
              <span className="label">Məzmun (AZ)</span>
              <textarea
                className="textarea"
                rows={7}
                value={contentAz}
                onChange={(e) => setContentAz(e.target.value)}
              />
            </div>

            <div>
              <span className="label">Məzmun (EN)</span>
              <textarea
                className="textarea"
                rows={7}
                value={contentEn}
                onChange={(e) => setContentEn(e.target.value)}
              />
            </div>

            <div>
              <span className="label">Məzmun (RU)</span>
              <textarea
                className="textarea"
                rows={7}
                value={contentRu}
                onChange={(e) => setContentRu(e.target.value)}
              />
            </div>

            <div className="hr" />

            <div>
              <span className="label">Tarix daxil et</span>

              <DatePicker
                className="input"
                selected={manualInsertedDate}
                onChange={(d) => setManualInsertedDate(d)}
                placeholderText="Tarix və saat seç"
                dateFormat="dd.MM.yyyy HH:mm"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={5}
                timeCaption="Saat"
                isClearable
              />
            </div>

            <div className="hr" />

            <div>
              <span className="label">YouTube video linki</span>

              <input
                type="url"
                className="input"
                value={youtubeLink}
                onChange={(e) => setYoutubeLink(e.target.value)}
                placeholder="https://www.youtube.com/watch?v=..."
              />

              <div style={{ marginTop: 6, opacity: 0.65, fontSize: 12 }}>
                Link əlavə olunarsa, saytda şəkilin yerində YouTube videosu göstəriləcək.
              </div>
            </div>

            <div className="hr" />

            <div>
              <span className="label">Şəkil</span>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files?.[0] || null)}
              />

              <div style={{ marginTop: 6, opacity: 0.65, fontSize: 12 }}>
                YouTube linki varsa, public hissədə əsas olaraq video görünəcək. Link boşdursa şəkil görünəcək.
              </div>
            </div>

            <div className="btnRow">
              <button className="btn btnPrimary" disabled={saving}>
                {saving ? "Saving..." : "Yadda saxla"}
              </button>

              <button type="button" className="btn" onClick={() => nav("/news")}>
                Ləğv et
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}